import { render, staticRenderFns } from "./actualizarArchivosEmpresa.vue?vue&type=template&id=20a6bf9b&"
import script from "./actualizarArchivosEmpresa.vue?vue&type=script&lang=js&"
export * from "./actualizarArchivosEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports